import { useEffect } from 'react';
import { logError } from 'lib/semanticMetrics';

export const useErrorLog = (tags: Record<string, any>) =>
  useEffect(() => {
    logError({ context: 'error-page', ...tags });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
